import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-edit-fare-tax',
    templateUrl: 'dialog.editfaretax.html',
    styleUrls: ['./dialog.editfaretax.css']
})
export class EditFareTaxDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    editFareTaxForm: FormGroup;
    loading: boolean = false;
    errorMessage: string = '';

    constructor(public dialogRef: MatDialogRef<EditFareTaxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.editFareTaxForm = new FormGroup({
            pukalNo: new FormControl({ value: this.data.AccNo, disabled: false }),
            fareObjId: new FormControl({ value: this.data.FareObjId, disabled: false }),
            taxObjId: new FormControl({ value: this.data.TaxObjId, disabled: false })
        });
    }

    onSave(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.loading = true;
            let fareTaxDetail = {
                TaxId: this.data.TaxId,
                Acc_No: this.editFareTaxForm.get('pukalNo')!.value,
                Fare_Obj_Id: this.editFareTaxForm.get('fareObjId')!.value,
                Tax_Obj_Id: this.editFareTaxForm.get('taxObjId')!.value
            }

            let save_sub = this.administrationService.updateFareTaxDetails(fareTaxDetail)
                .subscribe(
                    (value) => {
                        this.loading = false;
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            this.dialogRef.close('Edit successful');
                        } else {
                            this.openSnackBar('Error edit fare tax list.', '');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}